import { gql } from "apollo-boost"

export const getBeneficiariesCount = gql`
query BeneficiariesCount {
  CensusBeneficiariesCount
}
`